<template>
    <table cellspacing="0" border="0" style="font-family: Arial, Helvetica, sans-serif;" class="q-ma-lg">
        <colgroup width="25"></colgroup>
        <colgroup width="73"></colgroup>
        <colgroup width="197"></colgroup>
        <colgroup width="42"></colgroup>
        <colgroup width="55"></colgroup>
        <colgroup width="84"></colgroup>
        <colgroup width="82"></colgroup>
        <tr>
            <td style="border-top: 1px solid #000000; border-left: 1px solid #000000" height="14" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000; border-right: 1px solid #000000" align="left"><br></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="23"
                align="center"><b><font size=4>Invoice # {{ bill.number }}</font></b></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="23"
                align="center"><b><font size=4>{{ bill.created_at }}</font></b></td>
        </tr>
        <tr>
            <td style="border-top: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                colspan=2 height="33" align="left" valign=top><b><font size=2>Receiver:</font></b></td>
            <td style="border-top: 1px solid #000000" colspan=4 align="left" valign=middle>
                <font size=2>
                    Company name: <b>{{ requisites.name_in_signature }}</b>
                    <br>
                    IBAN Code: <b>{{ requisites.checking_account }}</b>
                    <br>
                    Name of the bank: <b>{{ requisites.bank_name }}</b>
                    <br>
                    Bank SWIFT Code: <b>PBANUA2X</b>
                    <br>
                    Company address: <b>{{ requisites.address }}</b>
                </font>
            </td>
            <td style="border-top: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=top><font
                size=2><br></font></td>
        </tr>
        <tr v-if="requisites.additional_info">
            <td style="border-left: 1px solid #000000" height="16" align="left"><br></td>
            <td style="border-right: 1px solid #000000" align="left"><br></td>
            <td style="border-top: 1px solid #000000;" align="left" colspan=2>
                <b><font size=2>{{ requisites.additional_info }}</font></b>
            </td>
            <!--      <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000" align="left"><br></td>-->
            <td style="border-top: 1px solid #000000;" align="left"><br></td>
            <td style="border-top: 1px solid #000000;" align="left"><br></td>
            <td style="border-top: 1px solid #000000; border-right: 1px solid #000000"
                align="left"><br></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000; border-top: 1px solid #000000;"
                colspan=2 height="16"
                align="left" valign=top><b><font size=2>Payer:</font></b></td>
            <td style="border-right: 1px solid #000000; border-top: 1px solid #000000;" colspan=5 align="left"
                valign=middle>
                <font size=2>
                    <span>
                        Company name: <b>{{ receiver ? receiver : 'Private person' }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.edrpou">
                        Tax ID: <b>{{ userRequisites.edrpou }} </b>
                        <br>
                    </span>
                    <span v-if="userRequisites.inn">
                        VAT Number: <b>{{ userRequisites.inn }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.iban">
                        IBAN Code: <b>{{ userRequisites.iban }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.legal_address">
                        Company address: <b>{{ userRequisites.legal_address }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.actual_address">
                        Company address: <b>{{ userRequisites.actual_address }}</b>
                        <br>
                    </span>
                    <span v-if="userRequisites.full_name">
                        <b>
                            {{
                                userRequisites.user_position
                                    ? `${userRequisites.user_position} ${userRequisites.full_name}`
                                    : userRequisites.full_name
                            }}
                        </b>
                        <br>
                    </span>
                </font></td>
        </tr>
        <tr>
            <td style="border-left: 1px solid #000000; border-right: 1px solid #000000; border-top: 1px solid #000000;"
                colspan=2 height="16"
                align="left" valign=middle><b><font size=2>Service code:</font></b></td>
            <td style="border-right: 1px solid #000000; border-top: 1px solid #000000;" colspan=5 align="left"
                valign=middle>
                <font size=2>
                    {{ bill.project.service_code }}
                </font></td>
        </tr>
        <tr>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="32" align="center" valign=middle><b><font size=2>#</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                colspan=2 align="center" valign=middle><b><font size=2>Name of services</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="center"><b><font size=2>Currency</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="center" valign=middle><b><font size=2>Quantity</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="center" valign=middle><b><font size=2>Price (vat excl.)</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="center" valign=middle><b><font size=2>Amount without VAT</font></b></td>
        </tr>
        <tr>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="46" align="right" valign=top sdval="1" sdnum="1033;"><font size=2>1</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                colspan=2 align="left" valign=top><font size=2>{{ bill.destination }}</font>
            </td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="left" valign=top><font size=2>{{
                    bill.service ? 'US' + bill.service.service.unit : 'US$'
                }}</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="1" sdnum="1033;"><font size=2>1</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                size=2>{{ (bill.amount / 100).toFixed(2) }}</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                size=2>{{ (bill.amount / 100).toFixed(2) }}</font></td>
        </tr>
        <tr v-if="bill.paid_amount > 0 && bill.paid_amount < bill.amount">
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="46" align="right" valign=top sdval="1" sdnum="1033;"><font size=2>2</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                colspan=2 align="left" valign=top><font size=2>Already paid</font>
            </td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="left" valign=top><font size=2>US$</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="1" sdnum="1033;"><font size=2>1</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                size=2>{{ (bill.paid_amount / 100).toFixed(2) }}</font></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" valign=top sdval="22940" sdnum="1033;0;0.00"><font
                size=2>{{ (bill.paid_amount / 100).toFixed(2) }}</font></td>
        </tr>
        <tr>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="24" colspan=6 align="right"><b><font size=2>Total Due:</font></b></td>
            <td
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                size=2>{{ (finalAmount / 100).toFixed(2) }}</font></td>
        </tr>
        <tr>
            <td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                height="24" colspan=6 align="right"><b><font size=2>VAT amount:</font></b></td>

            <td v-if="isNDSPayer && new Date(this.bill.true_created_at) > new Date('2020-01-31 23:59:00')"
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                size=2>Without VAT*</font>
            </td>
            <td v-else
                style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000"
                align="right" sdval="22940" sdnum="1033;0;#,##0.00_р_."><font
                size=2>Without VAT</font>
            </td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
        </tr>
        <td v-if="isNDSPayer && new Date(this.bill.true_created_at) > new Date('2020-01-31 23:59:00')"
            align="left" colspan=6 valign=top><b><i><font size=2>
            {{ requisites.custom_data }}
            <br></font></i></b>
        </td>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left" colspan=6 valign=top><b><i><font size=2><br>Total amount: {{
                    Math.floor(finalAmount / 100)
                }}
                dollars {{ finalAmount % 100 }} cents, Without VAT </font></i></b></td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
        </tr>
        <tr>
            <td height="15" align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
            <td align="left"><font size=2><br></font></td>
        </tr>
        <tr>
            <td colspan=5 align="left" style="position: relative;">
                <font size=2>Issued by __________________ /{{ requisites.name_in_signature }}/</font>
                <img v-if="requisites.stamp_img_url" :src="requisites.stamp_img_url" alt="" class="stamp">
            </td>
        </tr>
        <td align="left" colspan=6 valign=top><b><i><font size=2>
            <br>Attention! Please ensure to specify the invoice number {{ bill.number }} in the payment reference.
        </font></i></b>
        </td>
    </table>
</template>

<script>
export default {
    name: 'DataGrid',

    props: {
        bill: {
            type: Object,
            required: true,
        },

        requisites: {
            type: Object,
            required: true,
        },

        userRequisites: {
            type: Object,
            required: true,
        },

        ndsData: {
            type: Object,
            required: true,
        },
    },

    computed: {
        receiver () {
          if (!this.userRequisites.company_name && this.bill.status === 'PAID') {
            return null
          }

          return this.userRequisites.company_name
            ? this.userRequisites.company_name
            : this.bill.project.payment_data?.company_name
        },

        isOtherService () {
            return this.bill.destination.includes(
                'Розширення функціоналу комп\'ютерної програми (програмної продукції)')
        },

        finalAmount () {
            return (this.bill.paid_amount < this.bill.amount)
                ? this.bill.amount - this.bill.paid_amount
                : this.bill.amount
        },

        isNDSPayer () {
            return this.ndsData.ndsPayer === 1
        },
    },
}
</script>

<style scoped>
.stamp {
    position: absolute;
    z-index: -1;
    width: 200px;
    height: auto;
    left: 80px;
    top: -47px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/Invoice/global/DataGrid.vue